import { useLocation } from 'react-router-dom';
import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation } from 'react-query';

export function useDeleteChatflowConnections() {
  const location = useLocation();
  const segments = location.pathname.split('/');
  const agentId = segments[2];

  return useMutation({
    mutationFn: async (connections: number[]) => {
      const res = await $api.delete(
        stringifyUrl({ url: `v1/chat-flow/block/connection/${agentId}`, query: { connections } })
      );

      return res.data;
    }
  });
}
